import { z } from 'zod';

/** The bell's inbox is a bounded popover, not a table, so it takes a plain `limit` rather than the paged list query. */
export const NOTIFICATIONS_DEFAULT_LIMIT = 20;
export const NOTIFICATIONS_MAX_LIMIT = 50;

export const notificationListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(NOTIFICATIONS_MAX_LIMIT).default(NOTIFICATIONS_DEFAULT_LIMIT),
});
export type NotificationListQuery = z.infer<typeof notificationListQuerySchema>;

export interface NotificationView {
  id: string;
  type: string;
  title: string;
  body: string;
  entityType: string;
  entityId: string;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationUnreadCount {
  unread: number;
}
